import React from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import PhoneInTalkRoundedIcon from '@material-ui/icons/PhoneInTalkRounded';
import TrackChangesRoundedIcon from '@material-ui/icons/TrackChangesRounded';
import Alert from '@material-ui/lab/Alert';

import { RoleplayDifficultyFields } from '../RoleplayDifficultyFields';
import { RoleplayProfileFields } from '../RoleplayProfileFields';
import { DividerStyled, ListStyled, SaveButtonStyled } from '../styles';

import { CALL_GOALS, COPIES, FORM_FIELDS_MAP } from './JobOrderRoleplayScenarioSelector.constants';

export const JobOrderRoleplayProfileFields = ({ disabled = false, isFetching }) => {
  return (
    <Box display="flex" flexDirection="column" mt={2}>
      <RoleplayProfileFields
        disabled={disabled}
        formFieldsMap={FORM_FIELDS_MAP}
        labelPrefix={COPIES.scenarios.callCandidate.labelPrefix}
      />

      <RoleplayDifficultyFields disabled={disabled} formFieldsMap={FORM_FIELDS_MAP} />

      <DividerStyled />

      <Box display="flex" flexDirection="column" gridGap={24} mt={4}>
        <Box alignItems="center" display="flex" flexDirection="row" gridGap={8}>
          <TrackChangesRoundedIcon />
          <Typography variant="subtitle1">{COPIES.callGoals}</Typography>
        </Box>

        <ListStyled>
          {CALL_GOALS.map(callGoal => (
            <li key={callGoal}>
              <Typography color="textSecondary" variant="body1">
                {callGoal}
              </Typography>
            </li>
          ))}
        </ListStyled>

        <Alert severity="info">{COPIES.infoAlert}</Alert>

        <DividerStyled />

        {!disabled ? (
          <SaveButtonStyled
            fullWidth
            isSaving={isFetching}
            startIcon={
              isFetching ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <PhoneInTalkRoundedIcon />
              )
            }
            text={COPIES.form.mainAction}
          />
        ) : null}
      </Box>
    </Box>
  );
};
